import styled from "styled-components";
import { Grid, MenuItem, Typography } from "@mui/material";

import { Paper, TextField } from "../../../components";
import { colors } from "../../css components/Style";

const MainHeading = styled(Typography)`
  font-weight: 600;
  font-size: 20px;
  line-height: 33px;
  color: ${colors.purple};
`;

const Menu = styled(MenuItem)`
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
`;

export default function FormTwo({ formikProps, editState }) {
  return (
    <Paper gridSpacing={6}>
      <Grid size={12}>
        <MainHeading>Access Privileges</MainHeading>
      </Grid>

      <Grid size={6}>
        <TextField
          select
          formikProps={formikProps}
          name="role"
          disabled={!editState}
          label="Select Role"
          sx={{
            "& .MuiSvgIcon-root": {
              display: !editState && "none",
            },
          }}
          SelectProps={{
            displayEmpty: true,
          }}
        >
          <Menu value="" disabled>
            Select Role
          </Menu>
          <Menu value="Administrator">Administrator</Menu>
          <Menu value="NORMAL_USER">NORMAL USER</Menu>
        </TextField>
      </Grid>
    </Paper>
  );
}
